import { CustomerInfo } from "frontend/presentation/configuration/domain/types"
import { defineStore } from "pinia"
import { Nullable } from 'frontcore/presentation/types'

interface IStateCustomerConfiguration {
  customerInfo: Nullable<CustomerInfo>
}

export const useCustomerConfiguration = defineStore('CustomerConfiguration', {
  state: (): IStateCustomerConfiguration => ({
    customerInfo: null,
  }),
  actions: {
    setCustomerInfo (customerInfo: CustomerInfo) {
      this.customerInfo = customerInfo
    },
  },
  getters: {
    getCustomerInfo (state: IStateCustomerConfiguration) {
      return state.customerInfo
    },
  },
})
